import { render } from "./ProductReviewComponent.vue?vue&type=template&id=43df39b9"
import script from "./ProductReviewComponent.vue?vue&type=script&lang=js"
export * from "./ProductReviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/review/ProductReviewComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43df39b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43df39b9', __exports__)) {
    api.reload('43df39b9', __exports__)
  }
  
  module.hot.accept("./ProductReviewComponent.vue?vue&type=template&id=43df39b9", () => {
    api.rerender('43df39b9', render)
  })

}


export default __exports__